<div
  [ngClass]="bgColorClass()"
  class="inline-flex h-[22px] min-w-28 items-center justify-center truncate rounded-full px-3 py-1 text-[13px] text-white">
  {{ status() }}
</div>
